module.exports = __webpack_public_path__ + "static/media/Sharp-LQ084S3LG11-Mechanical-Drawing.630712aa.gif";